/**
 * Standardizes column widths for all tables to ensure a consistent format.
 */
const BASE_WIDTH_COLUMNS: Record<string, number> = {
	DATE: 155, // any column using date format, and this width is minimum for excel file format
	ACTIVE: 120, // any column using ToggleButton
	COMPANIES: 220, // any column using CompaniesByIds any format
	TAXI_SERVICE: 220, // any column using TaxiService once format fill
	NOTES: 220, // any column using Notes
	BALANCE: 150, // any column using Balance
	NAME: 260, // any column using Name small format
} as const;

export default BASE_WIDTH_COLUMNS;
